exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root {\n  --black: #000;\n  --white: #fff;\n}\n\n._2ztp_IlN35jTYpX8TiuYgU {\n  background-color: var(--black);\n  color: var(--white);\n}\n\n._2QxXNoRZs8ehuP8QgD9wA {\n  font-size: 18px;\n}\n", ""]);

// exports
exports.locals = {
	"baseStyle": "_2ztp_IlN35jTYpX8TiuYgU",
	"someStyle": "_2QxXNoRZs8ehuP8QgD9wA _2ztp_IlN35jTYpX8TiuYgU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/gavinyuetest.css
// module id = 103
// module chunks = 0